import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from '@mui/material/Alert';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";

import NavBar from "../components/NavBar";
import axios from "../components/Axios";
import { clearCdnCookie } from "../app/cdnCookie";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: "",
      name: "",
      email: "",
      phone_number: "",
      password: "",
      code: "",
      terms: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    //set fields based on query
    let params = new URLSearchParams(window.location.search);
    for (let k of ["name", "email", "code"]) {
      let v = params.get(k);
      if (v != null) this.setState({ [k]: v });
    }
  }

  handleChange(e) {
    let v = e.target.value;
    if (e.target.name === "terms") v = e.target.checked;
    this.setState({ [e.target.name]: v });
  }

  submit(e) {
    e.preventDefault();

    if (this.state.terms === false) {
      this.setState({
        errorMessage: "Plese click the checkbox to accept Terms and Privacy",
      });
      return;
    }

    this.setState({ loading: true, errorMessage: "" });
    axios
      .post("/user", {
        email: this.state.email,
        user_name: this.state.name,
        phone_number: this.state.phone_number,
        password: this.state.password,
        code: this.state.code,
        language: this.props.i18n.language
      })
      .then(
        function (response) {
          //this.setState({items: response.data});
          if ("error_code" in response.data) {
            this.setState({
              loading: false,
              errorMessage: response.data.message,
            });
          } else {
            this.setState({ loading: false });
            localStorage.setItem("token", response.data.api_access_token);
            localStorage.setItem("user_id", response.data.user_info.user_id);
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.user_info)
            );
            //axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            clearCdnCookie(); // a CDN cookie set in this tab may be another user's
            window.location.replace("/");
            //this.props.history.push("/");
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          if (error.response.status === 400 || error.response.status === 409) {
            this.setState({ errorMessage: error.response.data.message });
          } else {
            this.setState({ errorMessage: "Unknown Error" });
          }
          console.log(error.response);
          this.setState({ loading: false });
        }.bind(this)
      );
  }

  render() {
    return (
      <div className="background">
        <NavBar />
        <Container maxWidth="xs" style={{ marginTop: "64px" }}>
          <Typography variant="h5" gutterBottom className="loginTitle">
            <Trans>Create a new account</Trans>
          </Typography>

          <p className="loginText">
            <Trans>Enter your details below</Trans>
          </p>
          <form onSubmit={this.submit}>
            <label htmlFor="username" className="formLabel">
              <Trans>Name</Trans>
            </label>
            <br />
            <TextField
              name="name"
              autoFocus
              id="username"
              variant="outlined"
              size="small"
              value={this.state.name}
              onChange={this.handleChange}
              type="text"
              fullWidth
            />
            <br />
            <br />
            <label htmlFor="email" className="formLabel">
              <Trans>Email address</Trans>
            </label>
            <br />
            <TextField
              name="email"
              id="email"
              variant="outlined"
              size="small"
              value={this.state.email}
              onChange={this.handleChange}
              type="email"
              fullWidth
              required
            />
            <br />
            <br />
            <label htmlFor="password" className="formLabel">
              <Trans>Password</Trans>
            </label>
            <br />
            <TextField
              name="password"
              id="password"
              variant="outlined"
              size="small"
              value={this.state.password}
              onChange={this.handleChange}
              fullWidth
              required
              type="password"
            />

            {this.state.errorMessage !== "" && (
              <Alert
                style={{ marginTop: "16px" }}
                severity="error"
                onClose={() => {
                  this.setState({ errorMessage: "" });
                }}
              >
                {this.state.errorMessage}
              </Alert>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "32px 0",
              }}
            >
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="terms"
                      checked={this.state.terms ? true : false}
                      onChange={this.handleChange}
                      color="primary"
                      className="CheckBox"
                    />
                  }
                  label={
                    <>
                      <Trans>I accept the</Trans>{" "}
                      <a
                        target="_blank"
                        href="/terms"
                        style={{ color: "#063E6C" }}
                      >
                        <Trans>Terms</Trans>
                      </a>{" "}
                      <Trans>and</Trans>{" "}
                      <a
                        target="_blank"
                        href="/privacy"
                        style={{ color: "#063E6C" }}
                      >
                        <Trans>Privacy</Trans>
                      </a>
                    </>
                  }
                />
              </div>
              <Button
                className="Button ButtonPrimary"
                size="small"
                type="submit"
                disabled={this.state.loading}
              >
                <Trans>Register</Trans>
              </Button>
            </div>
          </form>

          <div className="registerBox">
            <div>
              <Trans>Already have an account?</Trans>{" "}
              <Link to="/login" style={{ textDecoration: "underline" }}>
                <Trans>Login here.</Trans>
              </Link>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(withRouter(Index));
